import { createContext, useContext } from "react";

const ActiveDistrictContext = createContext({
  activeUser: null,
  setActiveUser: () => undefined,
});
export const useActiveDistrictContext = () => useContext(ActiveDistrictContext);

const HeaderContext = createContext({
  showMenu: null,
  setShowMenu: () => undefined,
});
export const useHeaderContext = () => useContext(HeaderContext);

const FooterContext = createContext({
  showFooter: null,
  setShowFooter: () => undefined,
});
export const useFooterContext = () => useContext(FooterContext);

export const ActiveDistrictContextProvider = ({
  children,
  value,
  headerValue,
  footerValue,
}) => (
  <ActiveDistrictContext.Provider value={value}>
    <HeaderContext.Provider value={headerValue}>
      <FooterContext.Provider value={footerValue}>
        {children}
      </FooterContext.Provider>
    </HeaderContext.Provider>
  </ActiveDistrictContext.Provider>
);
